<script>
  import GeneralButton from "../../../components/button/GeneralButton.svelte"; 
  export let group1_cols;
  export let group2_cols;
  export let group3_cols;
  export let toggleGroupVisibility;
  export let visibility;
  export let startDrag;
  export let tableData;
  export let deleteCompleted;
  export let disable_buttons;
  export let sendResultTime;
  export let fixedTable;
  export let handleScrollF;
  export let tableHeight;
  
  function syncScroll(event) {
    const scrollTableContainer = document.querySelector('.scrollable-table-container');
    scrollTableContainer.scrollTop = event.target.scrollTop;
  }

  function parseHtmlParts(htmlString) {
    const el = document.createElement('div');
    el.innerHTML = htmlString;

    return Array.from(el.childNodes).map(n => ({
      type: n.className, // e.g., 'date-part' or 'time-part'
      value: n.textContent
    }));
  }

function enrichTableRow(row) {
  const keysToTransform = [
    "Work_ResultStartTime",
    "Work_ResultEndTime",
    "Work_OperationProductionStartTime",
    "Work_OperationProductionEndTime"
  ];

  keysToTransform.forEach(key => {
    if (typeof row[key] === 'string' && row[key].includes('date-part')) {
      row[`${key}_parts`] = parseHtmlParts(row[key]);
    }
  });

  row.__cellStyles = {};
  const fixedHeight = '45px';

  const allCols = [...group1_cols, ...group2_cols, ...group3_cols];

  allCols.forEach(col => {
    if (col.key === "Work_Lateness") {
      const base = `width: ${col.width}px; height: ${fixedHeight}; max-height: ${fixedHeight};`;
      const highlight = row[col.key] > 0 ? "color: red; font-weight: bold;" : "";
      row.__cellStyles[col.key] = `${base} ${highlight}`;
    } else {
      row.__cellStyles[col.key] = `width: ${col.width}px; max-width: ${col.width}px; height: ${fixedHeight}; max-height: ${fixedHeight};`;
    }
  });

  return row;
}

  $: tableData = tableData.map(enrichTableRow)
</script>

<div class="fixed-table-container" style="height: {tableHeight}px;" bind:this={fixedTable} id="fixed-table" on:wheel={handleScrollF} on:scroll={syncScroll} on:mousedown={startDrag}>
  <table>
    <thead>
      <tr>
        {#each [group1_cols, group2_cols, group3_cols] as group_cols}
          {#each group_cols as col, i}
            {#if i === 0}
              <th id="th_{col.key}" class="{col.group}" style="width: {col.width}px; height: 60px; max-height: 60px;">
                <div class="button-container">
                  <button style="cursor:pointer; padding: 1px 6px; border: 1px solid black;" on:click={() => toggleGroupVisibility(col.group)}>{#if $visibility[col.group]} - {:else} + {/if}</button>
                </div>
                {@html col.name}
              </th>
              <th id="resizer_{col.key}" class="{col.group} resizer" style="width: 5px; cursor: ew-resize; border: 0; padding: 0;"></th>
            {:else}
              {#if $visibility[col.group]}
                <th id="th_{col.key}" class="{col.group}" style="width: {col.width}px; height: 60px; max-height: 60px;">{@html col.name}</th>
                <th id="resizer_{col.key}" class="{col.group} resizer" style="width: 5px; cursor: ew-resize; border: 0; padding: 0;"></th>
              {/if}
            {/if}
          {/each}
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each tableData as row}
        <tr>
          {#each [group1_cols, group2_cols, group3_cols] as group_cols}
            {#each group_cols as col, i}
              {#if i === 0 || $visibility[col.group]}
                {#if col.key === "completedReset"}
                  {#if row.Work_ResultStartTime !== "" || row.Work_ResultEndTime !== ""}
                    <td class="{col.group}" style="{row.__cellStyles[col.key]}">
                      <GeneralButton buttonFunction={() => deleteCompleted(row)} buttonDisabled={disable_buttons} buttonText="削除" buttonType="negative" buttonExtraStyle="min-width: 60px; margin-left: 2px; margin-right:2px; font-size: 12px;"/>
                    </td>
                  {:else}
                    <td class="{col.group}" style="{row.__cellStyles[col.key]}"></td>
                  {/if}
                {:else if col.key === "Work_OperationProductionStartTime" || col.key === "Work_OperationProductionEndTime" }
                  <td style="{row.__cellStyles[col.key]} white-space: normal; word-wrap: break-word; overflow-y: auto;">
                    {#each row[`${col.key}_parts`] ?? [] as part}
                      <span class="{part.type}">{part.value}</span>
                    {/each}
                  </td>
                {:else if col.key === "Work_ResultStartTime"}
                  {#if row.Work_ResultStartTime !== ""}
                    <td class="{col.group}" style="{row.__cellStyles[col.key]} color: #57B59F">
                      {#each row[`${col.key}_parts`] ?? [] as part}
                        <span class="{part.type}">{part.value}</span>
                      {/each}
                    </td>
                  {:else}
                    <td class="{col.group}" style="{row.__cellStyles[col.key]}">
                      <GeneralButton buttonFunction={() => sendResultTime(row, true)} buttonDisabled={disable_buttons} buttonText="開始" buttonExtraStyle="min-width: 60px; margin-left: 2px; margin-right:2px; font-size: 12px;"/>
                    </td>
                  {/if}
                {:else if col.key === "Work_ResultEndTime"}
                  {#if row.Work_ResultEndTime !== ""}
                    <td class="{col.group}" style="{row.__cellStyles[col.key]} color: #57B59F">
                      {#each row[`${col.key}_parts`] ?? [] as part}
                        <span class="{part.type}">{part.value}</span>
                      {/each}
                    </td>
                  {:else}
                    <td class="{col.group}" style="{row.__cellStyles[col.key]}">
                      <GeneralButton buttonFunction={() => sendResultTime(row, false)} buttonDisabled={disable_buttons} buttonText="終了" buttonExtraStyle="min-width: 60px; margin-left: 2px; margin-right:2px; font-size: 12px;"/>
                    </td>
                  {/if}
                {:else}
                  <td style="{row.__cellStyles[col.key]} white-space: normal; word-wrap: break-word; overflow-y: auto;">
                    
                      {#if col.key.includes(' ')}
                        {#each col.key.split(' ') as key}
                          {row[key]}<br>
                        {/each}
                      {:else}
                        {row[col.key]}
                      {/if}
                    
                  </td>
                {/if}
                <td id="resizer_{col.key}" class="{col.group} resizer"></td>
              {/if}
            {/each}
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<style>
  .fixed-table-container {
    flex-shrink: 0;
    overflow-y: hidden;
    overflow-x: scroll;
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    
  }

  th, td {
    border: 1px solid #ddd;
    text-align: center;
    background-color: #fff;
    font-size: 10px;
    line-height: 1.2;
  }

  th {
    height: 60px;
    position: sticky;
    top: 0;
  }

  td {
    box-sizing: border-box;
  }

  .data-text {
    margin: 0;
    display: inline-block;
    white-space: normal;
    word-wrap: break-word; 
  }

  .scrollable-content {
    display: flex;
    flex-direction: column;
    justify-content: center;  /* Vertically center the content */
    min-height: 100%;         /* Ensure the content stretches vertically to enable centering */
  }

/*   td {
    height: 65px;
  } */

  /* style for fixed-table-container */
  th.group1 {
    background-color: #C2DDF8;

  }

  th.group2 {
    background-color: #BFCCF7;
  }

  th.group3 {
    background-color: #C5BCF7;

  }

  .button-container {
    position: absolute;
    top: 2px;
    left: 2px;
    border-radius: 2px;
    background-color: #F0F0F0;
  }

  .resizer {
    width: 5px; 
    cursor: ew-resize; 
    border: 0; 
    padding: 0;
  }

  .wrap {
    width:100%;
    height: auto;
    word-wrap: break-word;
    white-space: wrap;
  }

  :global(.negative) {
    font-size: 10px; 
  }

</style>